<template>
  <div class="box-border has-background-white h-100-per">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("userDetail.userDetailProduct") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("userDetail.userDetailProduct") }}
      </p>
      <div class="is-flex is-justify-end">
        <p
          v-if="getRule == 'startup'"
          class="pd-y-10 icon-color is-size-5 mg-r-10 cr-pointer"
          @click="$emit('ModalEdit'), $store.commit('setModalActive', true)"
        >
          <i class="fas fa-pen"></i>
        </p>
        <p
          class="pd-y-10 icon-color is-size-5 cr-pointer"
          @click="$emit('openModalInfo', 'pd-in')"
        >
          <i class="fas fa-question-circle"></i>
        </p>
      </div>
    </div>
    <p class="is-size-6 pd-y-5">
      <span class="has-text-weight-semibold"
        >{{ $t("userDetail.productName") }}:</span
      >
      <span class="th pd-l-5">{{
        getRule === "startup" && user.production != ""
          ? user.production
          : getRule !== "startup" && userDetail.production != ""
          ? userDetail.production
          : "-"
      }}</span>
    </p>
    <p class="is-size-6 pd-y-5">
      <span class="has-text-weight-semibold"
        >{{ $t("userDetail.productWeb") }}:</span
      >
      <span class="th pd-l-5">{{
        getRule === "startup" && user.websiteOfProduct != ""
          ? user.websiteOfProduct
          : getRule !== "startup" && userDetail.websiteOfProduct != ""
          ? userDetail.websiteOfProduct
          : "-"
      }}</span>
    </p>
    <p class="is-size-6 pd-y-5">
      <span class="has-text-weight-semibold"
        >{{ $t("userDetail.productIndustry") }}:</span
      >
      <span class="th pd-l-5">{{
        getBusinessType(
          getRule === "startup"
            ? user.productBatchs.typeOfBusiness
            : userDetail.typeOfBusiness
        )
      }}</span>
    </p>
    <p class="is-size-6 pd-y-5">
      <span class="has-text-weight-semibold"
        >{{ $i18n.locale === "th" ? levelType.name : levelType.nameEng }}:</span
      >
      <span class="th pd-l-5">{{
        getBusinessLevel(
          getRule === "startup"
            ? user.productBatchs.levelOfbusiness
            : userDetail.levelOfbusiness
        )
      }}</span>
    </p>
    <p class="is-size-6 pd-y-5">
      <span class="has-text-weight-semibold"
        >{{ $t("userDetail.productContractDate") }}:</span
      >
      <span class="th pd-l-5">{{
        (getRule === "startup"
          ? user.productBatchs.contractDate
          : userDetail.contractDate) | formatDateGobal
      }}</span>
    </p>
  </div>
</template>

<script>
import {
  getBusinessType,
  getBusinessLevel,
} from "@/service/getBusinessCompany";
export default {
  data() {
    return {};
  },
  watch: {
    user() {},
  },
  computed: {
    levelType() {
      let filter = this.$store.state.levelType.filter(
        (item) => item.id === this.batch.levelType
      );
      let res = "";
      if (filter.length !== 0) {
        res = filter[0];
      } else {
        res = [];
      }
      return res;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
  },
};
</script>